<template>
    <div>
        <TheSplitLayout class="min-h-screen">
            <template #primarySide>
                <div class="p-6 md:p-8 w-full flex flex-col justify-center items-center in-progress background">
                    <div class="w-[427px]">
                        <TheLogo
                            with-text
                            class="mb-6"
                        ></TheLogo>
                        <h2 class="font-works-sans text-2xl md:text-6xl lg:text-8xl font-extrabold text-center mb-2">
                            {{ t('welcome') }}
                        </h2>
                        <div class="text-slate-600 text-lg text-center pt-3 lg:pt-0 md:max-w-md p-12">
                            {{ t('welcomeSub') }}
                        </div>

                        <Platformstats
                            class="justify-between hidden max-w-md mx-auto lg:flex mt-13"
                            size="sm"
                        />
                    </div>
                </div>
            </template>
            <template #secondarySide>
                <div class="w-full flex flex-col justify-center items-center m-8">
                    <div>
                        <AuthForm
                            :type="authType"
                            class="w-screen max-w-md mx-auto p-7 md:p-8 bg-white md:rounded-lg bg-glassmorphic mb-8"
                            @update:type="switchPage"
                        />
                    </div>
                    <LocaleSwitcher class="mx-auto text-sm lg:order-2" />
                </div>
            </template>
        </TheSplitLayout>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AuthForm from '@/components/AuthForm';
import { mapGetters } from 'vuex';
import TheSplitLayout from '@/components/TheSplitLayout';
import TheLogo from '@/components/TheLogo';
import LocaleSwitcher from '@/components/LocaleSwitcher';
import Platformstats from '@/components/Platformstats';
import route from '@router/route';
import { useTranslation } from 'i18next-vue';

export default defineComponent({
    name: 'AuthShow',
    components: { Platformstats, LocaleSwitcher, TheLogo, TheSplitLayout, AuthForm },
    setup() {
        const { t } = useTranslation('authentication');
        return { t };
    },
    data() {
        return {
            authType: '',
            url: '' as symbol | string,
        };
    },
    computed: {
        ...mapGetters('auth', ['authDetails']),
    },
    created() {
        this.url = this.$route?.name || '';
        if (this.url === 'signup.show') {
            this.authType = 'register';
        } else {
            this.authType = 'login';
        }
    },
    methods: {
        switchPage() {
            if (this.url === 'signup.show') {
                window.location.href = route('login.show');
                return;
            }
            window.location.href = route('signup.show');
        },
    },
});
</script>
<style lang="scss" scoped>
.background {
    background-image: url(/images/backgrounds/brand-primary-blue.svg);
    background-repeat: no-repeat;
    &.in-progress {
        @screen lg {
            background-size: auto 100%;
        }
    }
    &.setup {
        background-size: cover;
    }
}
</style>
